// Angular imports
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// Common imports
import { Utils } from 'cc-common';

// Service imports
import { ServerErrorService } from '../../_services/shared-services/server-error.service';
import { UserService } from '../../_services/data-services/user.service';
import { HelperService } from '../../_services/shared-services/helper.service';

// Model imports
import { CloudDriveUrlResultDto } from '../../_models/cloud-drive-url-result-dto';

@Component({
    selector: 'app-user-cloud-drive',
    templateUrl: './user-cloud-drive.component.html',
    styleUrls: ['./user-cloud-drive.component.scss']
})
export class UserCloudDriveComponent implements OnInit {
    isUrlNotAvailable = false;

    constructor(
        private readonly router: Router,
        private readonly errorService: ServerErrorService,
        private readonly userService: UserService,
        private readonly helperService: HelperService
    ) {}

    ngOnInit(): void {
        this.userService.getCloudDriveUrl().subscribe(
            (result: CloudDriveUrlResultDto) => {
                if (Utils.notNullAndDefined(result.url) && Utils.notNullOrEmpty(result.url)) {
                    // Open the Cloud drive in new tab
                    this.helperService.openWindow(result.url, '_blank', null, null, false);

                    this.router.navigate(['home']);
                } else {
                    this.isUrlNotAvailable = true;
                }
            },
            (error) => {
                this.errorService.displayError(error);
                this.isUrlNotAvailable = true;
            }
        );
    }
}
